<template>
    <div class="container">
        <router-view></router-view>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";

    @Component
    export default class ExpertHome extends Vue {
    }
</script>

<style scoped lang="scss">
</style>
